import { makeTypeMetadataEntryFetchKey } from './cacheKeys';
import { batchedTypeMetadataRequest } from './typeMetadata';
import { wrapPromise } from 'persist-promise/wrapPromise';
export const persistedTypeMetadataPromise = wrapPromise({
  namespace: 'FDSR',
  entityName: 'typeMetadata',
  deepFreeze: true,
  toCacheKey: makeTypeMetadataEntryFetchKey,
  fetch: ({
    appSettingName,
    httpClient
  }) => batchedTypeMetadataRequest.queue({
    appSettingName,
    httpClient
  })
});